export const MACHINE_STATES = {
  installing: 'installing',
  installed: 'installed',
  producing: 'producing',
  sold: 'sold'
}

export const MACHINE_TYPES = {
  full_automatic_machine: 'full-automatic'
}

export const MACHINE_QUARTERS = {
  full_automatic_machine: 1
}
